import axiosInstance from '../../../config/axiosInstance';
import type {
  PVInvoice,
  PVInvoiceAllocation,
  PVInvoiceEligibleMovement,
  PVInvoiceKind,
  PVInvoicePaymentWrite,
  PVInvoiceStatus,
  PVInvoiceWrite,
} from '../types/projectVitalInvoices';

const base = '/project-vital/finance/invoices';

export async function listPVInvoices(params?: {
  kind?: PVInvoiceKind;
  state?: PVInvoiceStatus;
}): Promise<PVInvoice[]> {
  const { data } = await axiosInstance.get<PVInvoice[]>(base, {
    params: { ...params, limit: 200 },
  });
  return data;
}

export async function createPVInvoice(payload: PVInvoiceWrite): Promise<PVInvoice> {
  const { data } = await axiosInstance.post<PVInvoice>(base, payload);
  return data;
}

export async function updatePVInvoice(
  invoiceId: string,
  payload: PVInvoiceWrite,
): Promise<PVInvoice> {
  const { data } = await axiosInstance.put<PVInvoice>(`${base}/${invoiceId}`, payload);
  return data;
}

export async function listPVEligibleMovements(
  invoiceId: string,
): Promise<PVInvoiceEligibleMovement[]> {
  const { data } = await axiosInstance.get<PVInvoiceEligibleMovement[]>(
    `${base}/${invoiceId}/eligible-movements`,
  );
  return data;
}

export async function linkPVInvoiceMovement(
  invoiceId: string,
  movementId: string,
  amount: string,
): Promise<PVInvoice> {
  const { data } = await axiosInstance.post<PVInvoice>(
    `${base}/${invoiceId}/allocations`,
    { movement_id: movementId, allocated_amount: amount },
  );
  return data;
}

export async function unlinkPVInvoiceMovement(
  invoiceId: string,
  allocation: PVInvoiceAllocation,
): Promise<PVInvoice> {
  const { data } = await axiosInstance.delete<PVInvoice>(
    `${base}/${invoiceId}/allocations/${allocation.id}`,
  );
  return data;
}

export async function registerPVInvoicePayment(
  invoiceId: string,
  payload: PVInvoicePaymentWrite,
): Promise<PVInvoice> {
  const { data } = await axiosInstance.post<PVInvoice>(
    `${base}/${invoiceId}/payment`, payload,
  );
  return data;
}
